import { UsedProductsMap } from '@portal/processes/Content/utils';
import { StoreCode } from 'schema/storeCode';
import { getFormattedShopifyId } from 'shared/utils/shopify/ids';
import { SanityKeyed } from 'types/studio/studio';
import { ProductTypeOption } from './constants';
import type {
  ProductBaBFinalOption,
  ProductBaBVariant,
  ProductBaBVariantNormalized,
  ProductBaBVariantOrder,
  ShopifyCartItem
} from './types';

export type ProductdIdsType = Array<
  SanityKeyed<{
    _type: 'ProductIdsItem';
    targetStore: 'dev' | 'qa' | 'aud' | 'nzd' | 'eud' | 'ukd' | 'us' | 'au' | 'nz' | 'eu' | 'uk';
    productVariantId: string;
    sellingPlanId: string;
  }>
>;

export function getStoreProductVariantId(
  ProductIds: ProductdIdsType,
  storeCode: StoreCode
): string {
  const targetProductId = ProductIds.find(
    ({ targetStore }: { targetStore: string }) => targetStore === storeCode
  );

  return targetProductId ? targetProductId.productVariantId : '';
}

export function getFirstStepOption({
  variant,
  type,
  variantOrder
}: {
  variant: ProductBaBVariant;
  products?: UsedProductsMap;
  type: ProductTypeOption;
  variantOrder?: ProductBaBVariantOrder;
}): ProductBaBVariantNormalized {
  const firstOrderedVariant = variantOrder?.[0];
  const firstOrderedPrice = firstOrderedVariant ? variant[firstOrderedVariant]?.price : null;
  return {
    ...variant,
    minPrice: firstOrderedPrice || variant.singleSubscription.price || '',
    value: type
  };
}

export function addWelcomeKit(product: ProductBaBFinalOption, storeCode: StoreCode) {
  if (!product.welcomeKitIds) return [];

  const subscriptionType = product.productType;
  const targetWelcomeKit = product.welcomeKitIds.find(
    ({ targetStore }: { targetStore: StoreCode }) => targetStore === storeCode
  );

  return targetWelcomeKit
    ? [
        {
          merchandiseId: getFormattedShopifyId('ProductVariant', targetWelcomeKit.welcomeKitId),
          quantity: 1,
          attributes: [
            {
              // double underscore makes the custom attribute hidden on the checkout
              key:
                subscriptionType === 'One Time Purchase'
                  ? '__custom.otp_welcome_kit'
                  : '__custom.welcome_kit',
              value: 'true'
            }
          ]
        } as ShopifyCartItem
      ]
    : [];
}

export function formatDecimalOrIntegerPrice(price: string) {
  // Only show decimals if necessary
  return parseFloat(price) % 1 === 0 ? parseInt(price, 10) : parseFloat(price).toFixed(2);
}

const TRACKING_INTERNAL_PROMOTION_PAGE_STARTS = Object.freeze([
  'partner',
  'campaign',
  'nw/partner',
  'nw/campaign'
]);

export function trackingIsPageInternalPromotion(slug: string) {
  return TRACKING_INTERNAL_PROMOTION_PAGE_STARTS.some((start) => slug.startsWith(start));
}
